import Dispatcher from '../core/Dispatcher';
import { Constants } from '../constants';
import PriceAlertsApiUtils from '../utils/PriceAlertsApiUtils';

const PriceAlertsAction = {
  fetchAll(filters = {}) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.LOAD_PRICE_ALERTS
    });

    PriceAlertsApiUtils.getAll(filters);
  },

  getById(id) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.LOAD_PRICE_ALERT
    });

    PriceAlertsApiUtils.getOne(id);
  },

  skipAlert(alertId) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.SKIP_PRICE_ALERT,
      alertId:    alertId
    });

    PriceAlertsApiUtils.skipAlert(alertId);
  },

  bulkSkipAlerts(alertIds) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.BULK_SKIP_PRICE_ALERTS,
      alertIds:   alertIds
    });

    PriceAlertsApiUtils.bulkSkipAlerts(alertIds);
  },

  resolveAlert(alertId, newValue) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.RESOLVE_PRICE_ALERT,
      alertId:    alertId,
      newValue:   newValue
    });

    PriceAlertsApiUtils.resolveAlert(alertId, newValue);
  },

  deleteAlert(alertId) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.DELETE_PRICE_ALERT,
      alertId:    alertId
    });

    PriceAlertsApiUtils.deleteAlert(alertId);
  },

  getNewAlertsCount() {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.LOAD_NEW_ALERTS_COUNT
    });

    PriceAlertsApiUtils.getNewAlertsCount();
  },

  search(field, value) {
    Dispatcher.handleViewAction({
      actionType: Constants.ActionPriceAlerts.SEARCH_PRICE_ALERTS,
      field:      field,
      value:      value
    });
  }
};

export default PriceAlertsAction;
